import styles from '../ProductQuiz.module.scss';
import React, { useEffect } from 'react';
import { Button, Flex, Text } from '@mantine/core';
import { useProductQuiz } from '../ProductQuizContext';
import { QuestionTitle } from './QuestionTitle';
import { QuestionNextButton } from './QuestionNextButton';
import { quizQuestionPage } from '../../../lib/analytics/events';
import { Scrollable } from '../Helpers/Scrollable';
import { useTranslation } from 'react-i18next';

const EXERCISE_LEVELS = [
  'Leashed walks',
  'Night walks',
  'Hiking',
  'Roams free',
  'Dog parks',
  'Swimming',
  'Roams fenced-in yard',
  'Running',
];

export const QuestionExercise: React.FC = () => {
  const { t } = useTranslation();
  useEffect(() => {
    quizQuestionPage.quizPetTellUsMorePageEntered();
  }, []);

  const { quizAnswers, setQuizAnswers } = useProductQuiz();

  const addOrRemoveExercise = (name: string) => {
    const updatedExercise = new Set(quizAnswers.exercise);
    if (updatedExercise.has(name)) {
      updatedExercise.delete(name);
    } else if (!updatedExercise.has(name) && updatedExercise.size < 3) {
      updatedExercise.add(name);
    }
    setQuizAnswers({ ...quizAnswers, exercise: updatedExercise });
  };

  const items = EXERCISE_LEVELS.map((name) => {
    const limitReached = quizAnswers.exercise.size === 3;
    const selected = quizAnswers.exercise.has(name);

    return (
      <Button
        key={name}
        unstyled
        data-active={quizAnswers.exercise.has(name) || undefined}
        className={styles.quizButton}
        sx={{ borderRadius: 24, opacity: limitReached && !selected ? 0.5 : 1 }}
        onClick={() => {
          addOrRemoveExercise(name);
        }}
      >
        <Text
          size={16}
          weight={600}
          lh="120%"
          color="white"
          py={16}
          px={20}
          sx={(theme) => ({ color: quizAnswers.exercise.has(name) ? theme.colors['fi-yellow'] : 'white' })}
        >
          {name}
        </Text>
      </Button>
    );
  });

  return (
    <>
      <QuestionTitle subtitle={t('select_up_to_n', { count: 3 })}>
        {t('how_does_name_get_exercise', { name: quizAnswers.petName })}
      </QuestionTitle>
      <Scrollable>
        <Flex gap={12} justify="flex-start" align="flex-start" wrap="wrap" pr={4}>
          {items}
        </Flex>
      </Scrollable>
      <QuestionNextButton
        showOnDesktop={true}
        isDisabled={quizAnswers.exercise.size === 0}
        event={() => quizQuestionPage.quizTellUsMoreNext(Array.from(quizAnswers.exercise).sort().join(', '))}
      />
    </>
  );
};
